'use client';
import type { CerFeatures } from '@slims/shared/data';
import { Navigate, Outlet } from 'react-router-dom';
import { StatusBlock } from '@slims/ui/molecules';
import { useSelectedScopes } from '@/hooks/use-selected-scopes';

export function RequireFeature({ feature }: { feature: keyof CerFeatures }) {
	const { scopes, loading } = useSelectedScopes();
	if (loading) return <StatusBlock kind="loading" />;
	return scopes.some(
		(s) =>
			s.features?.[feature] !== false &&
			s.features?.[feature] !== 'disabled' &&
			s.features?.[feature] !== undefined,
	) ? (
		<Outlet />
	) : (
		<Navigate to="/dashboard" replace />
	);
}
